// import { FeatureStorage } from "@/_services/storage";

export default {
  computed: {
    tabs() {
      let validTabs = [
        {
          text: "All",
          path: `/sales-contract`,
          applicationFeatureCode: "CustomerSalesContract",
        },
        {
          text: "Balances",
          path: `/sales-contract-balance`,
          applicationFeatureCode: "ReportCustomerSalesContractBalance",
        },
      ];

      return validTabs;
    },
  },
};
